/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData/DateOfBirth/Content"
  
}) {
let personBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'birth_date',
format: fromFormat.dateShortIn,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 data="person.birth_date"
 format="/Data/format.js dateShortIn"
 text={personBirthDateValueData}
/>
{children}
</React.Fragment>)
}